import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
// import { UserOrganisationType } from "./useOrganisationDetailsQuery";

type AvailabilityApiResponse = ResponseType<{
  userAvailabilityId: string,
      userId: string,
      reason: string,
      startDate: Date,
      endDate: Date | null,
      createdAt: Date,
      updatedAt: Date
}>;

function useGetAvailabilityQuery(userID:string) {
  return useQuery<
    AxiosResponseAndError<AvailabilityApiResponse>["response"],
    AxiosResponseAndError<AvailabilityApiResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.getAvailabilityByUserID],
    queryFn: async () =>
      await ApiRequest.get(`${requestURLs.availability}user/${userID}`),
    enabled: !!userID,
  });
}

export default useGetAvailabilityQuery;